// The words on the "patient is not coming" banner, per kind.
//
// It headed every match "This reads as a cancellation". A reschedule is a
// cancellation plus a rebooking, and calling it only the first half sent the
// office to the wrong next step — free the slot and stop — when the patient
// was waiting to be offered another time. The heading is what the office
// reads before doing the next thing, so it has to name the thing.
//
// Nothing here changes what the buttons do: the action is still "take this
// appointment off the calendar" in every case. Only the words differ.

export type NotComingKind = 'cancel' | 'reschedule' | 'cannot-make-it';

export interface CancellationBannerCopy {
  heading: string;
  caption: string;
  /** Shown instead of the appointment list when there is nothing booked. */
  nothingBooked: string | null;
  action: string;
  dismiss: string;
}

export function cancellationBannerCopy(
  kind: NotComingKind | null | undefined,
  hasBooking: boolean,
): CancellationBannerCopy {
  switch (kind) {
    case 'reschedule':
      return {
        heading: 'This reads as a reschedule',
        caption: 'Take the current time off the calendar, then offer new ones below. The patient is texted that this visit is off.',
        nothingBooked: hasBooking ? null : 'This patient has nothing booked, so there is nothing to move — offer times below.',
        action: 'Free up this time',
        dismiss: 'Not a reschedule',
      };
    case 'cannot-make-it':
      return {
        heading: 'The patient says they cannot make it',
        caption: 'They may want another time or none. Free the slot if so. Doing that texts the patient that this visit is off.',
        nothingBooked: hasBooking ? null : 'This patient has nothing booked, so there is nothing to free.',
        action: 'Free up this time',
        dismiss: 'They are still coming',
      };
    // 'cancel', and an older server that sends no kind at all.
    default:
      return {
        heading: 'This reads as a cancellation',
        caption: 'Cancelling frees the slot for someone else. The patient is texted that this visit is off.',
        nothingBooked: hasBooking ? null : 'This patient has nothing booked, so there is nothing to cancel.',
        action: 'Cancel appointment',
        dismiss: 'Not a cancellation',
      };
  }
}
